import { useContext, useMemo } from "react";
import { Dropdown, MenuProps } from "antd";
import { ICellRendererParams } from "ag-grid-community";
import { useDispatch, useSelector } from "react-redux";
import { MdOutlineInsights } from "react-icons/md";
import { mainContext } from "@ts/constants";
import { updateDeepDiveModalDisplay } from "@features/modalSlice";
import {
    IChannel,
    IValueNumber,
    ParentModule,
    Platforms,
} from "@ts/common-types";
import { getActiveModule, getClientId } from "@ts/utils";

import { usePermissionCheck } from "@/hooks/AllCustomHooks";

const PADeepDiveButtonRenderer = (params: ICellRendererParams) => {
    const dispatch = useDispatch();
    const { setSelectedSKU } = useContext(mainContext);
    const link = useMemo(
        () =>
            `/${Platforms.ACTIVATION}/${ParentModule.PRODUCT_DEEPDIVE}?category=all&subcategory=all&sku=${params?.data?.asin}`,
        [params]
    );
    const channel = useSelector((state: IChannel) => state.channel.value);
    const clientGroup = useSelector(
        (state: { activeClientGroupId: IValueNumber }) =>
            state.activeClientGroupId.value
    );
    const client = getClientId();
    const moduleName = getActiveModule().activeModule;

    const handleOpen = () => {
        const locationHash = btoa(
            `${client}:${channel}:${moduleName}:${params.data.asin}: ${clientGroup}`
        );
        window.location.hash = `#modal:${locationHash}`;
    };
    const { isModuleEditDisabled } = usePermissionCheck({ type: "cellRenderer" });

    const items: MenuProps["items"] = [
        {
            label: "Open",
            key: "1",
            onClick: () => {
                handleOpen();
                setSelectedSKU(params.data.asin);
                dispatch(updateDeepDiveModalDisplay(true));
            },
        },
        {
            label: "Open in New Tab",
            key: "2",
            onClick: () => window.open(link, "_blank"),
        },
    ];

    return (
        <>
            {params.node.rowPinned ? null : (
                <Dropdown menu={{ items }} trigger={["hover"]} disabled={isModuleEditDisabled}>
                    <MdOutlineInsights
                        role="button"
                        className={`fs-5 ${isModuleEditDisabled ? "text-muted" : "text-dark"} `}
                    />
                </Dropdown>
            )}
        </>
    );
};

export default PADeepDiveButtonRenderer;
